@if (index == 0) {
  <div class="grid container-height">
      <div class=" col-12 md:col-7 lg:col-8">
        <div class=" flex flex-column md:flex-row column-gap-0 gap-2 right">
          <p-button icon="pi pi-save" styleClass="p-button mr-2" (onClick)="addRequest()"></p-button>
          <p-button icon="pi pi-question" styleClass="p-button mr-2" (click)="displayHelp = true"></p-button>
          <p-button label="{{'Count' | translate}}" icon="pi pi-calculator" (onClick)="onCount()" styleClass="p-button mr-2"></p-button>
          <p-button label="{{'Srch' | translate}}" icon="pi pi-search" (onClick)="onSearch()" styleClass="p-button mr-2"></p-button>
        </div>
      </div>
    <div class="col-12 md:col-7 lg:col-8">
      <div class=" flex flex-column md:flex-row column-gap-0 gap-2 grid justify-content-between">
        <div class="p-inputgroup col-10">
          <input autoFocus autocomplete="off" pInputText placeholder="{{'KeyWord' | translate}} *" [(ngModel)]="keyword"/>
        </div>
        <div class="p-inputgroup col-2">
          <p-selectButton [options]="stateOptions" [(ngModel)]="condition1" optionLabel="label"
          optionValue="value"></p-selectButton>
        </div>
        <div class="p-inputgroup col-10">
          <input pInputText placeholder="{{'KeyWord' | translate}}" [(ngModel)]="keyword1"/>
        </div>
        <div class="p-inputgroup col-2">
          <p-selectButton [options]="stateOptions" [(ngModel)]="condition2" optionLabel="label"
          optionValue="value"></p-selectButton>
        </div>
        <div class="p-inputgroup col-10 ">
          <input pInputText placeholder="{{'KeyWord' | translate}}" [(ngModel)]="keyword2"/>
        </div>
        <div class="p-inputgroup col-2">
          <p-selectButton [options]="stateOptions" [(ngModel)]="condition3" optionLabel="label"
          optionValue="value"></p-selectButton>
        </div>
        <div class="p-inputgroup col-12 ">
          <input pInputText placeholder="{{'KeyWord' | translate}}" [(ngModel)]="keyword3"/>
        </div>
        <div class="p-inputgroup col-6">
          <p-calendar placeholder="{{'Date_More' | translate}}" styleClass="min-w-full" class="min-w-full"
          dateFormat="dd/mm/yy" [(ngModel)]="dateBegin" [showClear]=true></p-calendar>
        </div>
        <div class="p-inputgroup col-6">
          <p-calendar placeholder="{{'Date_Less' | translate}}" styleClass="min-w-full" class="min-w-full"
          dateFormat="dd/mm/yy" [(ngModel)]="dateEnd" [showClear]=true></p-calendar>
        </div>
        <div class="p-inputgroup col-12">
          <p-dropdown [options]="formatList" [(ngModel)]="formatType" optionLabel="label" optionValue="value"
            styleClass="min-w-full"
          class="min-w-full" placeholder="{{'Filter_For' | translate}}" [showClear]=true></p-dropdown>
        </div>
        <div class="col-12">
          <p-table
            #dt
            [selectionMode]="'single'"
            [columns]="listColumnsRequest"
            [value]="requests"
            [paginator]="false"
            [scrollable]="true"
            scrollHeight="18rem"
            responsiveLayout="scroll"
            [breakpoint]="'960px'"
            (onRowSelect)="showDetails($event)"
            (onRowUnselect)="unSelect()"
            >
            <ng-template pTemplate="caption">
              <span class="header-grid-wrapper">
                <span class="align-right">{{'Tot' | translate}} {{ requests.length }} {{'Query_1' | translate}}</span>
              </span>
            </ng-template>
            <ng-template let-columns pTemplate="header">
              <tr>
                <th [pSortableColumn]="columns[0].field" class="width-auto">
                  <p-sortIcon [field]="columns[0].field"></p-sortIcon>
                  {{ columns[0].header }}
                  <input
                    (click)="$event.stopPropagation()"
                    pInputText
                    type="text"
                    (input)="dt.filter($event.target.value, columns[0].field, 'contains')"
                    style="color: darkgrey;"
                    />
                  </th>
                  <th [pSortableColumn]="columns[1].field" class="width-auto">
                    <p-sortIcon [field]="columns[1].field"></p-sortIcon>
                    {{ columns[1].header }}
                    <input
                      (click)="$event.stopPropagation()"
                      pInputText
                      type="text"
                      (input)="dt.filter($event.target.value, columns[1].field, 'contains')"
                      style="color: darkgrey;"
                      />
                    </th>
                    <th style="width: 3em"></th>
                  </tr>
                </ng-template>
                <ng-template let-rowData let-columns="columns" pTemplate="body">
                  <tr [pSelectableRow]="rowData">
                    <td class="width-auto">
                      {{ rowData[columns[0].field] }}
                    </td>
                    <td class="width-auto">
                      {{ rowData[columns[1].field] }}
                    </td>
                    <th>
                      <i
                        class="icons8-trash-can iconstyle"
                        (click)="deleteRequest($event, rowData)"
                        style="color:red;"
                      ></i>
                    </th>
                  </tr>
                </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">{{'Empty' | translate}}</td>
                </tr>
              </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-5 lg:col-4 ">
          <div class="flex mb-1">
            <p-checkbox
              class="p-field"
              [(ngModel)]="checkFilter"
              binary="true"
              (onChange)="onChangeCkFilter($event)"
              name="checkFilter"
              inputId="checkFilter"
            ></p-checkbox>
            <label for="checkFilter" class="ml-2">{{'Filter' | translate}}</label>
          </div>
          <p-tree
            filter="true"
            styleClass="h-50rem overflow-auto"
            filterPlaceholder="{{'Filter' | translate}}"
            [value]="treeIndex"
            selectionMode="single"
            [(selection)]="selectedFile"
            (onNodeSelect)="nodeSelect($event)"
            (onNodeExpand)="nodeExpand($event)"
            [emptyMessage]="'No_TreeLoad' | translate"
            >
            <ng-template let-node pTemplate="default">
              <span id={{node.key}}>
                {{ node.label }}
              </span>
            </ng-template>
            <ng-template pTemplate="footer">
              @if (loadTree === false) {
                <span style="font-weight: bolder;">
                  {{'TreeLoad' | translate}}
                </span>
              }
            </ng-template>
          </p-tree>
        </div>
      </div>
    }


    <div class="width-100">
      @if (index == 1) {
        <div class="display-block">
          {{'Srch_In_1' | translate}}
          <div class="right">
            @if (displayListResult === true) {
              <button                
                class="btnsize"
                type="button" pButton
                pTooltip="{{'Return_Res' | translate}}"
                icon="pi icons8-retour" styleClass="p-button-success"
                (click)="returnList()"
              ></button>
            }
            @if (displayCriteria === true) {
              <button
                class="btnsize margin-left"
                type="button" pButton
                pTooltip="{{'Return_Cri' | translate}}"
                tooltipPosition="left"
                icon="pi icons8-home" styleClass="p-button-success"
                (click)="returnCriteria()"
              ></button>
            }
          </div>
        </div>
        <displayresult
          #dispresult
          [srchMode]="srchMode"
          [resultDisplay]="resultDisplay"
          [btnAction]="true"
          [nbDoc]="nbDoc"
          [listColumns]="listColumns"
          [infoList]="infoList"
          [currentSelectedBsk]="{}"
          [listBskVariable]="[]"
          [basketMoveAll]="[]"
          [curPage]="curPage"
          [request]="currentRequest"
          [isDesktop]="isDesktop"
          [autoDocId]="''"
          [fetchParam]="fetchParam"
          (onReturnResult)="onReturnResult($event)"
          (onAction)="onAction($event)"
          (onNextDocs)="onNextDocs()"
          >
        </displayresult>
      }
    </div>

    <p-sidebar [(visible)]="displayHelp" position="bottom" [baseZIndex]="10000" [style]="{ height: '70%' }">
      <div class="scroll-table">
        <div id="titlehelp">Aide recherche plein texte</div>
        <div id="firsthelp">
          Il est possible de créer des requêtes de recherche plein texte en utilisant la syntaxe de requête avancée.
          Cette syntaxe s’appuie sur des mots clés. Ci-dessous en voici une liste des plus utilisés.
        </div>
        <div class="grid">
          <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
            <h4 class="align">Les syntaxes</h4>
            <p-card styleClass="mb-2 p-1">
              <ng-template pTemplate="header">
                <div class="align text-primary">
                  <span class="font-bold text-lg">Recherche par type</span>
                </div>
              </ng-template>
              Il est possible d'utiliser la syntaxe <b>Type:</b> afin de rechercher par type
              de document. <br/><br/>Exemple (Type:video ou Type:Word)
            </p-card>
            <p-card styleClass="mb-2 p-1">
              <ng-template pTemplate="header">
                <div class="align text-primary">
                  <span class="font-bold text-lg">Recherche par date</span>
                </div>
              </ng-template>
              Il est possible d'utiliser la syntaxe <b>Date:</b> afin de rechercher par date
              de création des documents. <br/><br/>Exemple (Date : >2/10/10 &lt;2/1/11)
              <br/>permet de rechercher les fichiers crées entre le deux octobre 2010 et le
              deux janvier 2011.
            </p-card>
            <p-card styleClass="mb-2 p-1">
              <ng-template pTemplate="header">
                <div class="align text-primary">
                  <span class="font-bold text-lg">Recherche par taille</span>
                </div>
              </ng-template>
              Il est possible d'utiliser la syntaxe <b>Size:</b> afin de rechercher par type
              de document. <br/><br/>Exemple (Size :1800) permet de rechercher les fichiers
              de 1.8Mo
            </p-card>
          </div>
          <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
            <h4 class="align">les opérateurs</h4>
            <p-card styleClass="mb-2 p-1">
              <ng-template pTemplate="header">
                <div class="align text-primary">
                  <span class="font-bold text-lg">L'opérateur AND</span>
                </div>
              </ng-template>
              Il est possible d'utiliser l'opérateur <b>AND</b> afin de combiner les
              recherches. <br/><br/>
              Exemple (Type: Word AND Date : >2/10/10 &lt;2/1/11)<br/>Recherche tout les
              documents de type word crées entre le deux octobre 2010 et le deux janvier 2011
            </p-card>
            <p-card styleClass="mb-2 p-1">
              <ng-template pTemplate="header">
                <div class="align text-primary">
                  <span class="font-bold text-lg">L'opérateur OR</span>
                </div>
              </ng-template>
              Il est possible d'utiliser l'opérateur <b>OR</b> afin de multiplier les
              recherches. <br/><br/>
              Exemple (Type:video OR Type:Word) permet de rechercher les fichiers vidéo ou les
              fichiers word.
            </p-card>
          </div>
          <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
            <h4 class="align">les caractères joker</h4>
            <p-card styleClass="mb-2 p-1">
              <ng-template pTemplate="header">
                <div class="align text-primary">
                  <span class="font-bold text-lg">le caractère *</span>
                </div>
              </ng-template>
              Il est possible d'utiliser le caractère <b>'*'</b> afin de remplacer un
              caractère par n'importe lequel. <br/><br/>
              Exemple (BD*) permet de rechercher tout texte de trois lettre commencant par BD.
            </p-card>
            <p-card styleClass="mb-2 p-1">
              <ng-template pTemplate="header">
                <div class="align text-primary">
                  <span class="font-bold text-lg">le caractère =</span>
                </div>
              </ng-template>
                        Il est possible d'utiliser le caractère <b>'='</b> afin de limiter à un type.
                        <br/><br/>
                        Exemple (Type:=docx) ne retournera que des documents avec l'extension .docx et
              exluera les .doc
            </p-card>
            <p-card styleClass="mb-2 p-1">
              <ng-template pTemplate="header">
                <div class="align text-primary">
                  <span class="font-bold text-lg">le caractère -</span>
                </div>
              </ng-template>
              Il est possible d'utiliser le caractère <b>'-'</b> afin d'exclure une expression
              de la recherche. <br/><br/>
              Exemple (facture -client ) permet de rechercher les fichiers contenant le mot
              facture sans le mot client.
            </p-card>
          </div>
        </div>
      </div>
    </p-sidebar>

    <p-dialog
      [contentStyle]="{ overflow: 'inherit' }"
      header="{{'Query_4_Req' | translate}}"
      modal="modal"
      [(visible)]="displayUpdate"
      [closable]="true"
      (onHide)="closeDia($event)"
      width="600"
      >
      @if (displayUpdate) {
        <div class="grid">
          <div class="col-12">
            <span class="p-float-label size_cent">
              <input
                pInputText
                [(ngModel)]="labelRequest"
                autoFocus
                name="labelRequest"
                id="labelRequest"
                class="p-inputtext size_cent"
                type="text"
                />
                <label for="labelRequest">"{{'Col_Inti_1' | translate}}" *</label>
              </span>
            </div>
            <div class="col-12"></div>
            <div class="col-12 md:col-12 align-right">
              <button class="margin p-button-primary p-button-outlined" type="button" pButton (click)="displayUpdate = false"
              label="{{'Cancel' | translate}}"></button>
              <button class="margin" type="button" pButton (click)="validRequest()"
              label="{{'Valid' | translate}}"></button>
            </div>
          </div>
        }
      </p-dialog>

<countdocs [visible]="visibleCount" [anbdoc]="nbDocCount" (onAnbdocUpdate)="onCountDoc($event)"></countdocs>

<app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>
